import { useEffect } from "react";
import styled from "styled-components";
import { TextField } from "@mui/material";
import { Text } from "../Text";
import { useMobile } from "../../utils/mobile";

const InputContainer = styled.div`
  flex: 1 1 0%;
  margin-left: ${(props) => (props.isMobile ? "0" : "0.5em")};
  margin-right: ${(props) => (props.isMobile ? "0" : "0.5em")};
`;

const StyledInput = styled(TextField)`
  && {
    .MuiOutlinedInput-root {
      border-radius: 21px;
      background: transparent;
      border: 0;
    }

    .MuiOutlinedInput-notchedOutline {
      border: 0;
      background: #f6fafd;
      z-index: -1;
    }

    .MuiFormHelperText-root.Mui-error {
      /* Transient prop ($) so it styles here without reaching the DOM. */
      text-align: ${(p) => (p.$isRtl ? "right" : "left")};
    }

    input[type="number"]::-webkit-inner-spin-button,
    input[type="number"]::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    input[type="checkbox"] {
      background: rgb(0, 85 164);
    }
  }
`;

const StyledDiv = styled.div(({ theme, variant, error, color }) => ({
  borderRadius: 21,
  backgroundColor: variant === "outlined" ? theme.color.gray10 : "transparent",
  display: "flex",
  border:
    variant === "outlined"
      ? `1px solid  ${!!error ? "red" : color ? color : theme.color.primary}`
      : "none",
}));

const StyleEndImg = styled.img(({ ...props }) => ({
  marginInlineStart: "auto",
  width: 20,
  height: 20,
  alignSelf: "center",
}));

const StyleStartImg = styled.img(({ ...props }) => ({
  marginInlineStart: 12,
  marginInlineEnd: 12,
  width: 20,
  height: 20,
  alignSelf: "center",
}));

const inputLabelProps = {
  shrink: true,
  margin: "2rem",
};

const Label = styled("div")(({ theme }) => ({
  fontSize: 12,
  color: theme.color.label,
  fontWeight: 600,
  letterSpacing: 0.32,
  textAlign: "start",
  lineHeight: 3,
}));

const InputMUI = ({
  label,
  placeholder,
  width = "full",
  isRtl,
  fontSize,
  validation,
  errorText,
  value,
  startImg,
  endImg,
  showPassword,
  helperText,
  variant,
  // useInput returns these for the caller; they are not input attributes, so
  // keep them out of `props` and off the DOM element.
  validate,
  options,
  ...props
}) => {
  const error = errorText;
  const isMobile = useMobile();
  useEffect(() => { }, [value]);

  return (
    <InputContainer width={width} isMobile={isMobile} style={{ ...props.style }}>
      {label && <Label>{label}</Label>}
      <StyledDiv error={!!helperText} variant={variant} style={{ ...props.style }}>
        {!!startImg && <StyleStartImg src={startImg} alt="input-start-img" />}
        <StyledInput
          variant={variant}
          InputLabelProps={inputLabelProps}
          placeholder={placeholder || label}
          fullWidth={width === "full"}
          size="small"
          fontSize={fontSize}
          error={!!error}
          dir={isRtl === true ? "rtl" : "ltr"}
          {...props}
          $isRtl={isRtl}
        />
        {!!endImg && (
          <StyleEndImg
            src={endImg}
            alt="input-end-img"
            onClick={() => showPassword(props.type === "password")}
          />
        )}
      </StyledDiv>
      {!!helperText && <Text.Error>{helperText}</Text.Error>}
    </InputContainer>
  );
};

export default InputMUI;
